import { useEffect, useRef, useState } from "react";
import "./style.css"

interface ReportModalProps {
    path: string;
    id?: string;
}

const OpenImg: React.FC<ReportModalProps> = ({ path, id }) => {
    const closeRef = useRef<HTMLButtonElement | null>(null);
    const imgRef = useRef<HTMLImageElement | null>(null);

    return (
            <div className="modal-open-img modal fade"  style={{ background: "#000" }} id={id ? id : "modal-open-img"} tabIndex={-1} aria-labelledby="modal-denunciar-usaurio" aria-hidden="true">
            <div className="modal-dialog cover-mobile" style={{display: "flex", alignItems: "center"}}>
                <div className="modal-content" id="modal-content-open-img">
                    <div className="modal-header" onClick={() => closeRef.current?.click()}>
                        <button ref={closeRef} type="button" className="btn-close close-img" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body" style={{display: "flex", justifyContent: "center", background: "#000"}}>
                        <img alt="Imagem da publicação" onError={(e) => (e.currentTarget.src = "/img/image_not_found.png?v=1")} ref={imgRef} src={path} className="user-select-none" width="100%"/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OpenImg;
